(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
/* 
    © 2023 Bkthemes
    https://bkthemes.design

    IMPORTANT: We recommend that you do not edit this file,
    as you might lose changes when you upgrade our theme.
    Instead, you may add your own custom styles in the 
    "assets/custom.js" file.
*/

// Detect JavaScript
document.documentElement.classList.remove('no-js');
document.documentElement.classList.add('js');

// Detect touch
if ('ontouchstart' in window || navigator.maxTouchPoints) {
    document.documentElement.classList.remove('no-touch');
    document.documentElement.classList.add('touch');
}

// init Bootstrap tooltips
var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'));

tooltipTriggerList.map(function(tooltipTriggerEl) {
    return new bootstrap.Tooltip(tooltipTriggerEl);
});

},{}],2:[function(require,module,exports){

// Adjust sticky-top class for summary
function fixSummaryStickyTop() {
    const summaryEl = document.querySelector('#cart-nav-item');

    if (summaryEl && summaryEl.classList.contains('sticky-top')) {
        const navbarEl      = document.querySelector('#navbar.navbar-sticky');
        let navbarHeight    = 0;

        if (navbarEl) {
            navbarHeight = navbarEl.clientHeight;
        }

        summaryEl.style.top = navbarHeight + 20 + 'px';
        summaryEl.style.zIndex = 1019;
    }
}
fixSummaryStickyTop();

// Update quantity
function updateQuantityListeners() {
    const quantityFields = document.querySelectorAll('.product-item-qty');

    if (quantityFields.length > 0) {

        // Listen for change on option select fields
        Array.from(quantityFields).forEach(el => {
            el.addEventListener('change', () => {
                
                // Change product quantity
                fetch('/cart/change.js', {
                    method: 'post',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        line: el.dataset.line,
                        quantity: el.value
                    })
                })
                    .then(res => res.json())
                    .then(data => {
                        console.log(data);

                        // Update cart on navbar
                        fetch(window.location)
                            .then(res => res.text())
                            .then(data => {
                                const parser = new DOMParser();
                                const newDocument = parser.parseFromString(data, 'text/html');

                                document.querySelector('#shopify-section-cart-template').innerHTML = newDocument.querySelector('#shopify-section-cart-template').innerHTML;

                                fixSummaryStickyTop();
                                updateQuantityListeners();
                                removeProductListeners();
                            });
                    });
            });
        });
    }
}
updateQuantityListeners();

// Remove product
function removeProductListeners() {
    const removeButtons = document.querySelectorAll('.product-item-remove');

    if (removeButtons.length > 0) {

        // Listen for change on option select fields
        Array.from(removeButtons).forEach(el => {
            el.addEventListener('click', (e) => {
                e.preventDefault();

                el.disabled = true;
                
                // Change product quantity
                fetch('/cart/change.js', {
                    method: 'post',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        line: el.dataset.line,
                        quantity: 0
                    })
                })
                    .then(res => res.json())
                    .then(data => {
                        console.log(data);

                        // Update cart on navbar
                        fetch(window.location)
                            .then(res => res.text())
                            .then(data => {
                                const parser = new DOMParser();
                                const newDocument = parser.parseFromString(data, 'text/html');

                                document.querySelector('#cart-nav-item').innerHTML = newDocument.querySelector('#cart-nav-item').innerHTML;

                                fixSummaryStickyTop();
                                updateQuantityListeners();
                                removeProductListeners();
                            });
                    });
            });
        });
    }
}
removeProductListeners();

// Listen for Shopify theme editor changes
// https://help.shopify.com/en/themes/development/sections/integration-with-theme-editor
document.addEventListener('shopify:section:load', function(event) {
    if (event.detail.sectionId === 'cart-template') {
        fixSummaryStickyTop();
        updateQuantityListeners();
        removeProductListeners();
    }
});

},{}],3:[function(require,module,exports){

// Handle filtering
const filteringSelectEl = document.getElementById('collection-filtering-select');

if (filteringSelectEl) {
    filteringSelectEl.addEventListener('change', (event) => {
        if ('URLSearchParams' in window) {
            let searchParams = new URLSearchParams(window.location.search);
            if (searchParams.toString()) {
                window.location = event.target.value + '?' + searchParams.toString();
            } else {
                window.location = event.target.value;
            }
        }
    });
}

// Handle sorting
const sortingSelectEl = document.getElementById('collection-sorting-select');

if (sortingSelectEl) {
    sortingSelectEl.addEventListener('change', (event) => {
        if ('URLSearchParams' in window) {
            let searchParams = new URLSearchParams(window.location.search);
            searchParams.set('sort_by', event.target.value);
            window.location.search = searchParams.toString();
        }
    });
}

// Handle layout
const layoutBtnEl = document.getElementById('collection-layout-btn');

if (layoutBtnEl) {
    layoutBtnEl.addEventListener('click', (event) => {
        if ('URLSearchParams' in window) {
            let searchParams = new URLSearchParams(window.location.search);
            searchParams.set('type', event.currentTarget.dataset.value);
            window.location.search = searchParams.toString();
        }
    });
}

},{}],4:[function(require,module,exports){
  
// Google map code
const el = document.querySelector('.google-map');

if (el) {
    window.addEventListener('DOMContentLoaded', () => {

        setTimeout(() => {

            var script = document.createElement('script');
            script.src = `https://maps.googleapis.com/maps/api/js?key=${el.dataset.apiKey}&callback=initMap`;
            script.defer = true;
            script.async = true;

            window.initMap = function() {      
                const elArray = document.querySelectorAll('.google-map');

                elArray.forEach(el => {
                    const latLng = { 
                        lat: Number(el.dataset.lat), 
                        lng: Number(el.dataset.lng) 
                    };

                    const map = new google.maps.Map(el, {
                        center: latLng,
                        zoom: Number(el.dataset.zoom),
                    });

                    const marker = new google.maps.Marker({
                        position: latLng,
                        map
                    });

                    marker.addListener('click', () => {
                        el.closest('.google-map-wrapper')
                            .querySelector('.google-map-content')
                            .classList.remove('hide');
                    });
                });
            };

            document.head.appendChild(script);
        }, 500);
    });
}

// Handle close button
document.querySelectorAll('.google-map-btn-close').forEach(el => 
    el.addEventListener('click', (e) => {
        e.target.closest('.google-map-content')
            .classList.add('hide');
    })
);


// Listen for changes in Shopify Theme Editor
document.addEventListener('shopify:section:load', function (event) {
    if (document.getElementById(event.target.id).querySelector('.google-map')) {
        initMap();
    }
});
},{}],5:[function(require,module,exports){

// Handle sticky-top
var stickyNavbar = function () { 
    if (document.getElementById('navbar').classList.contains('navbar-sticky')) {
        document.getElementById('shopify-section-navbar')
            .classList.add('sticky-top');
    }
};

stickyNavbar();

// Listen for changes in Shopify Theme Editor
document.addEventListener('shopify:section:load', function (event) {    
    if (event.detail.sectionId === 'navbar') {
        stickyNavbar();
    }
});

},{}],6:[function(require,module,exports){

// Scroll to newsletter form after submit
if (window.location.href.indexOf('?customer_posted=true') > -1) {
    setTimeout(function() { 
        document.querySelector('.newsletter').scrollIntoView();
    }, 750);
}
},{}],7:[function(require,module,exports){

// Define elements
const formEl = document.querySelector('form[action="/cart/add"]');

if (formEl) {
    formEl.addEventListener('submit', (e) => {
        e.preventDefault();

        // Define elements
        const variantsJSON          = JSON.parse(formEl.closest('.product').dataset.variantsJson);
        const optionSelectors       = formEl.getElementsByClassName('option-select');
        const addToCartBtnEl        = formEl.closest('.product').querySelector('.add-to-cart-btn');
        const addToCartIconCart     = addToCartBtnEl.querySelector('.add-to-cart-btn-icon-cart');
        const addToCartTextEl       = addToCartBtnEl.querySelector('.add-to-cart-btn-text');
        const quantityEl            = formEl.querySelector('#qty');
        const cartNavItem           = document.querySelector('#cart-nav-item');
        const productTitle          = formEl.closest('.product').dataset.productTitle;
        const featuredImageSrc      = formEl.closest('.product').dataset.featuredImageSrc;

        
       
        

        // Get selected options so that we can find the selected variant
        let selectedOptions = [];
            
        Array.from(optionSelectors).forEach(el => {
            selectedOptions.push(el.value);
        });
        
        // Get selected variant based on options above
        let selectedVariant;

        variantsJSON.forEach(el => {
            if (el.title.includes(selectedOptions.join(' / '))) {
                selectedVariant = el;
            }
        });

      
window.addEventListener('variantChange.bkthemes.product', async (event) => {
    const respoonse = await fetch(window.location.href)
    const text = await respoonse.text()
    const newDocument = new DOMParser().parseFromString(text, 'text/html')

    
    document.querySelector('#product-qty-breaks')
        ?.replaceWith(newDocument.querySelector('#product-qty-breaks'))

    document.querySelector('.option-select')
        ?.replaceWith(newDocument.querySelector('.option-select'))

    
    initQtyBreaks()

   
})

        // Add product to cart
        fetch('/cart/add.js', {
            method: 'post',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                items: [
                    {
                        id: selectedVariant.id,
                        quantity: quantityEl.value || 1
                    }
                ]
            }),
            success: function(){
        if(typeof callback === 'function'){
            callback();
        }
         const form = document.querySelector(form);
         if (form.hasAttribute('data-bkthemes-upsell-modal')) return
         if (btn.closest('.modal')) return

    },
            error: function(){
              console.error('Error:', error);
            }
        })
            .then(res => res.json())
            .then(data => {
                console.log(data);
                if (data.items) {
                                        
                    // Update cart on navbar
                    fetch(window.location)
                        .then(res => res.text())
                        .then(data => {
                            const parser = new DOMParser();
                            const doc = parser.parseFromString(data, 'text/html');

                            cartNavItem.innerHTML = doc.querySelector(`#${cartNavItem.id}`).innerHTML;
                        });

                }

                
            });
    });
}


},{}],8:[function(require,module,exports){
// Get carousel
const carouselEl = document.getElementById('product-carousel');

// Handle product gallery active class (carousel)
if (carouselEl) {    
    carouselEl.addEventListener('slide.bs.carousel', event => {
        Array.from(carouselEl.getElementsByClassName('product-carousel-thumbnails-item')).forEach(function(el, index) {
            if (index == event.to) {
                el.classList.add('active');
                el.getElementsByTagName('img')[0]
                    .classList.add('border', 'border-secondary');
            } else {
                el.classList.remove('active');
                el.getElementsByTagName('img')[0]
                    .classList.remove('border', 'border-secondary');
            }
        });
    });
}
     
// Handle product gallery full-screen click
if (carouselEl) {
    carouselEl.querySelectorAll('.carousel-item a').forEach(item => {
        item.addEventListener('click', event => {
            event.preventDefault();
            if (document.fullscreenEnabled) {
                carouselEl.requestFullscreen();
            }
        });
    });
}

// Close full-screen with close button
const closeFullScreenBtn = document.getElementById('close-full-screen-btn');

if (closeFullScreenBtn) {
    closeFullScreenBtn.addEventListener('click', () => {
        document.exitFullscreen();
    });
}

// Adjust product gallery based on 'fullscreenchange' event
document.addEventListener('fullscreenchange', () => {
    if (document.fullscreenElement) {
        carouselEl.classList
            .add('full-screen');

        carouselEl.querySelectorAll('.carousel-item')
            .forEach(item => {
                const img = item.getElementsByTagName('img')[0];
                const newImgSrc = item.getElementsByTagName('a')[0].href;
                img.src = newImgSrc;
            });

    } else {
        carouselEl.classList.remove('full-screen');

        carouselEl.querySelectorAll('.carousel-item')
            .forEach(item => {
                const img = item.getElementsByTagName('img')[0];
                img.src = img.dataset.src;
            });
    }
});

// Handle pinch zoom
// https://github.com/GoogleChromeLabs/pinch-zoom

// Stop videos on slide change
if (carouselEl) {    
    carouselEl.addEventListener('slid.bs.carousel', event => {
        Array.from(carouselEl.getElementsByClassName('carousel-item'))
            .forEach(function(el, index) {

                if (index == event.from) {
                    let iframe = el.querySelector('iframe');
                    let video = el.querySelector('video');
                    
                    if (iframe) {
                        let iframeSrc = iframe.src;
                        iframe.src = iframeSrc;
                    }
                    if (video) {
                        video.pause();
                    }
                }

            });
    });
}

// Adjust sticky-top class for carousel
if (carouselEl && carouselEl.classList.contains('sticky-top')) {
    const navbarEl      = document.querySelector('#navbar.navbar-sticky');
    let navbarHeight    = 0;

    if (navbarEl) {
        navbarHeight = navbarEl.clientHeight;
    }

    carouselEl.style.top = navbarHeight + 20 + 'px';
    carouselEl.style.zIndex = 1019;
}
},{}],9:[function(require,module,exports){

// Define elements
const optionSelectors = document.getElementsByClassName('option-select');

if (optionSelectors.length > 0) {

    // Listen for change on option select fields
    Array.from(optionSelectors).forEach(el => {
        el.addEventListener('change', () => {
            let selectedOptions = [];
            
            // Get selected options
            Array.from(optionSelectors).forEach(el => {
                selectedOptions.push(el.value);
            });

            // Get selected variant based on selected options
            let selectedVariant;
            const variantsJSON = JSON.parse(el.closest('.product').dataset.variantsJson);

            variantsJSON.forEach(el => {
                if (el.title.includes(selectedOptions.join(' / '))) {
                    selectedVariant = el;
                }
            });

            console.log(selectedVariant);

            // Get elements that have to be updated on variant change
            const priceEl           = el.closest('.product').querySelector('.product-price');
            const addToCartBtnEl    = el.closest('.product').querySelector('.add-to-cart-btn');
            const addToCartTextEl   = addToCartBtnEl.querySelector('.add-to-cart-btn-text');
            const gallery           = el.closest('.product').querySelector('.product-carousel');

            // Variant exists
            if (selectedVariant) {

                // Update URL
                let params = new URLSearchParams(window.location.search);
                params.set('variant', selectedVariant.id);
                history.replaceState(null, null, `${location.pathname}?${params}`);

                // Update Compare at Price
                if (selectedVariant.compare_at_price > selectedVariant.price) {
                    priceEl.querySelector('.price-compare').classList.remove('d-none');
                    priceEl.querySelector('.price-compare').classList.add('d-inline-block');
                    priceEl.querySelector('.price-compare-text').innerHTML = Shopify.formatMoney(selectedVariant.compare_at_price);
                } else {
                    priceEl.querySelector('.price-compare').classList.remove('d-inline-block');
                    priceEl.querySelector('.price-compare').classList.add('d-none');
                    priceEl.querySelector('.price-compare-text').innerHTML = '';
                }

                // Update price
                priceEl.querySelector('.price').innerHTML = Shopify.formatMoney(selectedVariant.price);

                // Update gallery
                if (selectedVariant.featured_media) {
                    let selectedIndex = 0;

                    const carouselItems = gallery.querySelectorAll('.carousel-item');

                    Array.from(carouselItems).forEach((el, index) => {
                        if (el.dataset.mediaId == selectedVariant.featured_media.id) {
                            selectedIndex = index;
                        }
                    });

                    const carousel = new bootstrap.Carousel(gallery);

                    carousel.to(selectedIndex);
                    carousel.pause();
                }

                // Variant is available
                if (selectedVariant.available) {

                    // Update Add to cart button
                    addToCartBtnEl.disabled = false;
                    addToCartTextEl.innerHTML = window.theme.i18n.product.add_to_cart;
                }

                // Variant is sold-out
                else {

                    // Update Add to cart button
                    addToCartBtnEl.disabled = true;
                    addToCartTextEl.innerHTML = window.theme.i18n.product.sold_out;
                }
                          
            }
            // Variant is unavailable
            else {

                // Update Add to cart button
                addToCartBtnEl.disabled = true;
                addToCartTextEl.innerHTML = window.theme.i18n.product.unavailable;
            }
          const customEvent = new CustomEvent('variantChange.bkthemes.product', {
                  detail: selectedVariant
              })
               window.dispatchEvent(customEvent)
        });
    });
}

},{}],10:[function(require,module,exports){

// https://www.shopify.com/partners/blog/related-products
var loadProductRecommendationsIntoSection = function() {

    // Look for an element with class 'product-recommendations'
    var productRecommendationsSection = document.querySelector('.recommended-products');
    
    if (productRecommendationsSection === null) { 
        return; 
    }

    // Read product id from data attribute
    var productId = productRecommendationsSection.dataset.productId;

    // Read limit from data attribute
    var limit = productRecommendationsSection.dataset.limit;

    // Build request URL
    var requestUrl = '/recommendations/products?section_id=product-recommended&limit='+limit+'&product_id='+productId;

    // Create request and submit it using Ajax
    var request = new XMLHttpRequest();
    request.open('GET', requestUrl);
    request.onload = function() {
        if (request.status >= 200 && request.status < 300) {
            var container = document.createElement('div');
            container.innerHTML = request.response;
            productRecommendationsSection.innerHTML = container.querySelector('.recommended-products').innerHTML;
        }
    };
    request.send();
};

// If your section has theme settings, the theme editor
// reloads the section as you edit those settings. When that happens, the
// recommendations need to be fetched again.
// See https://help.shopify.com/en/themes/development/sections/integration-with-theme-editor
document.addEventListener('shopify:section:load', function(event) {
    if (event.detail.sectionId === 'product-recommended') {
        loadProductRecommendationsIntoSection();
    }
});

// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();
},{}],11:[function(require,module,exports){

// Autofocus search input field on dropdown open
document.getElementById('search-nav-item')
    .addEventListener('shown.bs.dropdown', function () {
        document.getElementById('minisearch-input').focus();
    });
},{}],12:[function(require,module,exports){

// Shopify Format Money
// https://gist.github.com/stewartknapman/8d8733ea58d2314c373e94114472d44c
Shopify.formatMoney = function(cents, format) {
    if (typeof cents == 'string') { cents = cents.replace('.',''); }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = (format || this.money_format);
   
    function defaultOption(opt, def) {
        return (typeof opt == 'undefined' ? def : opt);
    }
   
    function formatWithDelimiters(number, precision, thousands, decimal) {
        precision = defaultOption(precision, 2);
        thousands = defaultOption(thousands, ',');
        decimal   = defaultOption(decimal, '.');
    
        if (isNaN(number) || number == null) { return 0; }
    
        number = (number/100.0).toFixed(precision);
    
        var parts   = number.split('.'),
            dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
            cents   = parts[1] ? (decimal + parts[1]) : '';
    
        return dollars + cents;
    }
    
    switch(formatString.match(placeholderRegex)[1]) {
    case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
    case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
    case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
    case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
    }
    
    return formatString.replace(placeholderRegex, value);
};


// Shopify resize image
// https://gist.github.com/DanWebb/cce6ab34dd521fcac6ba
Shopify.resizeImage = function(src, size) {
    if (!src || !size) {
        return;
    }
    return src
        .replace(/_(pico|icon|thumb|small|compact|medium|large|grande|original|1024x1024|2048x2048|master)+\./g, '.')
        .replace(/\.jpg|\.png|\.gif|\.jpeg/g, function(match) {
            return '_'+size+match;
        })
    ;
};
},{}],13:[function(require,module,exports){

// Base scripts
require('./base');

// Theme scripts
require('./cart');
require('./collection');
require('./map');
require('./navbar');
require('./newsletter');
require('./product-add-to-cart');
require('./product-carousel');
require('./product-options');
require('./product-recommended');
require('./search');
require('./shopify');
},{"./base":1,"./cart":2,"./collection":3,"./map":4,"./navbar":5,"./newsletter":6,"./product-add-to-cart":7,"./product-carousel":8,"./product-options":9,"./product-recommended":10,"./search":11,"./shopify":12}]},{},[13]);
